module.exports = __webpack_public_path__ + "img/retroboy.dbe37857.webp";